import Dexie from 'dexie'

let Db = new Dexie("blackfon-pc")

Db.version(1).stores({
	configs: 'key,value'
})

export default Db
